$(document).ready(function () {
  const options = {
    mobileFirst: true,
    autoplay: false,
    dots: false,
    infinite: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 450,
        swipeToSlide: true,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 750,
        swipeToSlide: true,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 900,
        settings: 'unslick',
      },
    ],
  };

  $('.nearby-carousel')
    .on('destroy', function (ev, slick) {
      let carousel = $(this),
        reinit = debounce(function () {
          /*
           * slick.activeBreakpoint will tell us the breakpoint
           * at which the carousel was destroyed.
           */
          if (slick.activeBreakpoint < window.innerWidth) {
            return;
          }

          // Re-initialize with the old settings.
          carousel.slick(slick.options);

          // Remove this event listener.
          window.removeEventListener('resize', reinit);
        }, 500);

      // Assign our debounced callback to window.resize.
      window.addEventListener('resize', reinit);
    })
    .slick(options);
});
